import { Reveal } from "./Reveal";
import { APPS } from "./data";
import { ArrowRight, Check, Lock, CalendarClock, Trophy, Flame } from "lucide-react";

const ICONS = { socios: Flame, jugadores: Trophy, canchas: CalendarClock };

export const AppsShowcase = () => {
  return (
    <section id="apps" className="relative py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <span className="section-tag">Plataforma del club</span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-navy">
            Las apps que hacen funcionar al club
          </h2>
          <p className="mt-5 text-lg text-gray-600 leading-relaxed">
            Herramientas simples para socios y dirigentes. Reservá, gestioná y organizá sin vueltas.
          </p>
        </Reveal>

        <div className="mt-14 grid lg:grid-cols-3 gap-6 md:gap-8">
          {/* Featured app — Socios & Quincho */}
          <Reveal className="lg:col-span-2">
            <div className="group relative h-full overflow-hidden rounded-3xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 bg-navy text-white">
              <img
                src={APPS[0].image}
                alt={APPS[0].title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover opacity-30 group-hover:opacity-40 group-hover:scale-105 transition-all duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f1a44] via-[#1a2a6c]/80 to-[#1a2a6c]/30" />
              <div className="relative p-8 sm:p-10 flex flex-col h-full min-h-[26rem]">
                <span className="inline-flex w-fit items-center gap-1.5 text-xs font-bold uppercase tracking-wider bg-gold text-navy px-3 py-1 rounded-full">
                  {APPS[0].badge}
                </span>
                <div className="mt-auto">
                  <h3 className="text-2xl sm:text-3xl font-bold text-white">{APPS[0].title}</h3>
                  <p className="mt-3 text-white/85 max-w-lg leading-relaxed">{APPS[0].desc}</p>
                  <ul className="mt-5 grid sm:grid-cols-2 gap-2.5">
                    {APPS[0].features.map((f) => (
                      <li key={f} className="flex items-center gap-2 text-sm text-white/90">
                        <Check className="h-4 w-4 text-gold shrink-0" /> {f}
                      </li>
                    ))}
                  </ul>
                  <button
                    data-testid="app-cta-socios"
                    className="mt-7 inline-flex items-center gap-2 bg-gold text-navy font-bold px-6 py-3 rounded-xl hover:-translate-y-0.5 transition-transform shadow-lg"
                  >
                    {APPS[0].cta} <ArrowRight className="h-5 w-5" />
                  </button>
                </div>
              </div>
            </div>
          </Reveal>

          {/* Other apps stacked */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-1 gap-6 md:gap-8">
            {APPS.slice(1).map((app, i) => {
              const Icon = ICONS[app.id] || Trophy;
              return (
                <Reveal key={app.id} delay={0.1 + i * 0.1}>
                  <div className="group h-full bg-[#eef1f7] rounded-3xl border border-gray-100 p-7 hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
                    <div className="flex items-center justify-between">
                      <div className="h-12 w-12 rounded-xl bg-navy flex items-center justify-center">
                        <Icon className="h-6 w-6 text-gold" />
                      </div>
                      <span className="inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider text-gray-500 bg-white px-2.5 py-1 rounded-full border border-gray-200">
                        {app.badge}
                      </span>
                    </div>
                    <h3 className="mt-5 text-xl font-semibold text-navy">{app.title}</h3>
                    <p className="mt-2 text-gray-600 text-sm leading-relaxed">{app.desc}</p>
                    <button
                      data-testid={`app-cta-${app.id}`}
                      disabled={!app.available}
                      className={`mt-5 inline-flex items-center gap-1.5 text-sm font-bold ${
                        app.available ? "text-navy hover:gap-2.5" : "text-gray-400 cursor-default"
                      } transition-all`}
                    >
                      {!app.available && <Lock className="h-4 w-4" />}
                      {app.cta}
                      {app.available && <ArrowRight className="h-4 w-4" />}
                    </button>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
